import RolePermission from '@/api/RolePermission'

const transformRolePermission = (item = {}) => {
  return {
    permissionId: item.permission_id,
    title: item.title,
    permissions: item.permissions || [],
    createdAt: item.created_at,
  }
}

const transformRolePermissions = (items = []) => {
  return items.map((item) => transformRolePermission(item))
}

export default {
  namespaced: true,

  state: {
    rolePermissionList: transformRolePermissions([]),
    rolePermissionSingle: transformRolePermission({}),
  },

  mutations: {
    setRolePermissionList (state, data = []) {
      state.rolePermissionList = transformRolePermissions(data)
    },
    setRolePermissionSingle (state, data = {}) {
      state.rolePermissionSingle = transformRolePermission(data)
    },
  },

  actions: {
    async getRolePermissionList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getRolePermissionList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getRolePermissionList')

        const response = await RolePermission.getList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getRolePermissionList')

        result = response.data

        if (result.success) {
          commit('setRolePermissionList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getRolePermissionSingle ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getRolePermissionSingle') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getRolePermissionSingle')

        const response = await RolePermission.getSingle(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getRolePermissionSingle')

        result = response.data

        if (result.success && result.data.length) {
          commit('setRolePermissionSingle', result.data[0])
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createRolePermission ({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createRolePermission') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createRolePermission')

        const response = await RolePermission.insert(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createRolePermission')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateRolePermission ({ commit }, { id, data }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateRolePermission') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateRolePermission')

        const response = await RolePermission.update(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateRolePermission')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deleteRolePermission ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deleteRolePermission') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deleteRolePermission')

        const response = await RolePermission.delete(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deleteRolePermission')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/RolePermission.js